const Rails = require('rails-ujs');
Rails.start();
